import { ICatFilters } from "../state/catalogueState";
import * as catalogueAPIUtil from "../../util/catalogue/catalogueAPIUtil";
import { User } from "../../models/User";
import { ICatalogue } from "../../interfaces/ICatalogue";

import { ICatalogueListResponse } from "../../interfaces/ICatalogueResponse";
import MCatalogueListItem from "../../models/MCatalogueListitem";
import { IArtwork } from "../../interfaces/IArtwork";
import { MArtwork } from "../../models/MArtwork";
export const RECEIVE_CATALOGUE_LIST = "[Catalogue] RECEIVE_CATALOGUE_LIST";
export const RECEIVE_CATALOGUE = "[Catalogues List] RECEIVE_CATALOGUE";
export const FETCH_ERROR = "[Catalogues List] FETCH_ERROR";
export const IS_LOADING = "[Catalogues List] IS_LOADING";
export const CLEAR_FILTERS = "[Catalogue] CLEAR_FILTERS";
export const UPDATE_FILTERS = "[Catalogue] UPDATE_FILTERS";
export const RECEIVE_CATALOGUE_ITEM = "[Catalogue] RECEIVE_CATALOGUE_ITEM";
export const RECEIVE_CREATED_ORDER = "[Catalogue custom Order] RECEIVE_CREATED_ORDER";
export const RECEIVE_CATALOGUE_CATEGORIES = "[Categories] RECEIVE_CATALOGUE_CATEGORIES";
export const SET_URL_CATEGORY = "[Category] SET_URL_CATEGORY";
export const RECEIVE_DECORATION_TYPE = "[Types] RECEIVE_DECORATION_TYPE";
export const RECEIVE_DECORATION_LOCATIONS = "[Locations] RECEIVE_DECORATION_LOCATIONS";
export const UPDATE_CURRENT_ORDER = "[Current Order] UPDATE_CURRENT_ORDER";
export const RECEIVE_CARTWORK_DETAILS = "[Artwork Details] RECEIVE_CARTWORK_DETAILS";
export const RECEIVE_CARTWORKS_LIST = "[Artwork List] RECEIVE_CARTWORKS_LIST";
export const RECEIVE_CARTWORKS_LIST_BYID = 'RECEIVE_CARTWORKS_LIST_BYID'
export const RECEIVE_DECORATORS_TYPE_LIST =
  '[Decoratiors type List] RECEIVE_DECORATORS_TYPE_LIST'
export const RECEIVE_DECORATORS_VENDORS_LIST =
  '[Decoratiors vendors List] RECEIVE_DECORATORS_VENDORS_LIST'
export const RECEIVE_SIPPING_LOCATION = "RECEIVE_SIPPING_LOCATION";

export const receiveCatalogues = (
  catalogues: ICatalogue[],
  count: number,
  meta,
) => ({
  type: RECEIVE_CATALOGUE,
  payload: catalogues,
  count,
  meta,
})
export const receiveArtworkDetails = (artworkDetails: {}) => ({
  type: RECEIVE_CARTWORK_DETAILS,
  payload: artworkDetails,
})
export const receiveArtworks = (artworks: IArtwork[]) => ({
  type: RECEIVE_CARTWORKS_LIST,
  payload: artworks,
})
export const receiveArtworksById = (artworks) => ({
  type: RECEIVE_CARTWORKS_LIST_BYID,
  payload: artworks,
})
export const receiveDecoratorTypes = (types) => ({
  type: RECEIVE_DECORATORS_TYPE_LIST,
  payload: types,
})
export const receiveDecoratorVendors = (types) => ({
  type: RECEIVE_DECORATORS_VENDORS_LIST,
  payload: types,
})
export const receiveDecorationLocations = (types: []) => ({
  type: RECEIVE_DECORATION_LOCATIONS,
  payload: types,
})
export const receiveDecorationType = (types: []) => ({
  type: RECEIVE_DECORATION_TYPE,
  payload: types,
})
export const receiveCatalogueCustomRows = (order) => ({
  type: RECEIVE_CREATED_ORDER,
  payload: order,
})
export const receiveCatalogue = (catalogue: ICatalogue) => ({
  type: RECEIVE_CATALOGUE_ITEM,
  payload: catalogue,
})
export const receiveCatalogueCategories = (categories) => ({
  type: RECEIVE_CATALOGUE_CATEGORIES,
  payload: categories,
})
export const fetchCatalogues =
  (
    limit: number = 50,
    offset: number = 0,
    order: string = 'productName',
    orient: string = 'asc',
    filters: ICatFilters,
    isQuoteCatalogue: boolean,
  ) =>
  (dispatch) =>
    catalogueAPIUtil
      .fetchCatalogues(limit, offset, order, orient, filters, isQuoteCatalogue)
      .then((res) => {
        const catalogueResponse: ICatalogueListResponse = res.data
        const catalogueList: ICatalogue[] = catalogueResponse.data.map(
          (individualCatalogue) => {
            return new MCatalogueListItem(individualCatalogue)
          },
        )
        dispatch(
          receiveCatalogues(
            catalogueList,
            catalogueResponse.meta.page_count,
            catalogueResponse.meta,
          ),
        )
      })
      .catch((error) => {
        dispatch(isLoading(false))
        dispatch(sendFetchError())
      })
export const fetchCatalogue = (id, account_id) => (dispatch) =>
  catalogueAPIUtil
    .fetchCatalogue(id, account_id)
    .then((res) => {
      const catalogueres = res.data.data
      dispatch(receiveCatalogue(catalogueres))
    })
    .catch((error) => {
      dispatch(isLoading(false))
      dispatch(sendFetchError())
    })
export const fetchCatalogueCategories = () => (dispatch) =>
  catalogueAPIUtil
    .fetchCatalogueCategories()
    .then((res) => {
      const cate = res.data.data
      const categories = []
      if (cate.length > 0) {
        cate.map((c) => {
          categories.push(c.category)
        })
      }
      dispatch(receiveCatalogueCategories(categories))
    })
    .catch((error) => {
      dispatch(isLoading(false))
      dispatch(sendFetchError())
    })
export const createOrder = (data, ses) => (dispatch) =>
  catalogueAPIUtil
    .createOrder(data)
    .then((res) => {
      console.log(res)
      const Orderreceived = res.data.data
      if (Orderreceived.status == 'success') {
      } else {
      }
      //  dispatch(receiveCreatedOrder(Orderreceived))
    })
    .catch((error) => {
      console.log('products list error', error)
      dispatch(isLoading(false))
      dispatch(sendFetchError())
    })
export const fetchDecorationTypes = () => (dispatch) =>
  catalogueAPIUtil
    .fetchDecorationTypes()
    .then((res) => {
      dispatch(receiveDecorationType(res.data))
    })
    .catch((error) => {
      dispatch(isLoading(false))
      dispatch(sendFetchError())
    })
export const fetchDecorationLocations = () => (dispatch) =>
  catalogueAPIUtil
    .fetchDecorationLocations()
    .then((res) => {
      dispatch(receiveDecorationLocations(res.data))
    })
    .catch((error) => {
      dispatch(isLoading(false))
      dispatch(sendFetchError())
    })
export const fetchArtworkdetail = (id) => (dispatch) =>
  catalogueAPIUtil
    .fetchArtworkdetail(id)
    .then((res) => {
      dispatch(receiveArtworkDetails(res.data))
    })
    .catch((error) => {
      dispatch(isLoading(false))
      dispatch(sendFetchError())
    })
export const fetchArtworks = (filterData) => (dispatch) =>
  catalogueAPIUtil
    .fetchArtworks(filterData)
    .then((res) => {
      const artworks: MArtwork[] = res.data.data.map((individualOrder) => {
        return new MArtwork(individualOrder)
      })
      const pendingArtworkData = JSON.parse(localStorage.getItem('cpPendingArtwork') || '[]')
      artworks.unshift(...pendingArtworkData)
      dispatch(isLoading(false))
      dispatch(receiveArtworks(artworks))
    })
    .catch((error) => {
      dispatch(isLoading(false))
      dispatch(sendFetchError())
    })

export const fetchArtworksById = (filter) => (dispatch) =>
  catalogueAPIUtil
    .fetchArtworksById(filter)
    .then((res) => {
      const artworks = res.data.data.map((individualOrder) => {
        return individualOrder
      })
      dispatch(isLoading(false))
      dispatch(receiveArtworksById(artworks))
    })
    .catch((error) => {
      dispatch(isLoading(false))
      dispatch(sendFetchError())
    })
export const getDecoratorTypes = () => dispatch => catalogueAPIUtil.getDecoratorTypes()
    .then(res => {

        dispatch(isLoading(false));
        dispatch(receiveDecoratorTypes(res.data))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const getDecoratorVendors = () => dispatch => catalogueAPIUtil.getDecoratorVendors()
    .then(res => {

        dispatch(isLoading(false));
        dispatch(receiveDecoratorVendors(res.data))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const isLoading = (loading: boolean) => ({
    type: IS_LOADING,
    loading
});
export const setisLoading = (loading: boolean) => dispatch => {
    dispatch(isLoading(loading));
};

export const sendFetchError = () => ({
    type: FETCH_ERROR
});
export const setCategory = (cat) => ({
    type: SET_URL_CATEGORY,
    payload: cat
});

export const clearFilters = (currentUser: User) => ({
    type: CLEAR_FILTERS,
    currentUser
});

export const receiveFilterUpdate = (filter: { [key: string]: any }) => ({
    type: UPDATE_FILTERS,
    payload: filter,
});
export const updateCurrentOrder = (order) => ({
    type: UPDATE_CURRENT_ORDER,
    payload: order
});

export const receiveShippingLocation = (data) => ({
    type: RECEIVE_SIPPING_LOCATION,
    payload: data
});


export const fetchShippingLocation = (accountId) => dispatch => catalogueAPIUtil.fetchShippingLocations(accountId).then(res => {
    dispatch(isLoading(false));
    dispatch(receiveShippingLocation(res.data?.data || []))
  }).catch(error => {
    dispatch(isLoading(false));
    dispatch(sendFetchError());
  });
